import React from 'react';
import { Checkbox, Form as AntdForm, Typography, Row } from 'antd';
import { Action, AnyObject } from '@triare/auth-redux';
import { Callbacks, Rule } from 'rc-field-form/lib/interface';
import { FormProps as AntdFormProps } from 'rc-field-form/lib/Form';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useAuth } from '../../../../../store/auth';
import AlertSuccess, { AlertSuccessProps } from './Alert/Success';
import AlertError, { AlertErrorProps } from './Alert/Error';
import Submit from '../../../../Common/Form/Button/Submit';
import { LogoSmall } from '../../../../Common/Icon';

import styles from '../../index.module.scss';

interface FormProps<P> extends AntdFormProps {
  disableAlertSuccess?: true;
  requiredFields?: '*' | string[];
  validationRules: Rule;
  styles?: { [key: string]: string };

  alertSuccess?: AlertSuccessProps;
  alertError?: AlertErrorProps;

  signIn: (payload: P) => Action | void;
  onFinishFailed?: Callbacks<P>['onFinishFailed'];
  validateSubmit: (fieldsValue: AnyObject) => boolean;
}

function Form<P>({
  disableAlertSuccess = undefined,
  validationRules,
  validateSubmit,
  requiredFields = '*',
  form,
  styles: additionalStyles = {},
  children,
  alertSuccess = undefined,
  alertError = undefined,
  signIn,
  onFinishFailed,
  initialValues = { remember: true },
  ...props
}: React.PropsWithChildren<FormProps<P>>): JSX.Element {
  const {
    signIn: { loading, response },
  } = useAuth();

  return (
    <AntdForm
      className={clsx(styles.form, additionalStyles?.form)}
      name="signIn"
      autoComplete="off"
      layout="vertical"
      onFinish={signIn}
      onFinishFailed={onFinishFailed}
      initialValues={initialValues}
      {...props}
    >
      <Row justify="center">
        <LogoSmall />
      </Row>

      <Typography.Text className={styles.title}>Admin</Typography.Text>
      <Typography.Text className={styles.text}>Enter yout credentials to access your account</Typography.Text>
      <Typography.Text className={styles.text2}>Log in using your credentials</Typography.Text>

      <div className={styles.alertWrapper}>
        {disableAlertSuccess ? null : <AlertSuccess response={response} {...alertSuccess} />}
        <AlertError {...alertError} />
      </div>

      {children}

      <Row justify="space-between" className={styles.remember}>
        <AntdForm.Item
          className={clsx(styles?.remember, additionalStyles?.remember)}
          name="remember"
          valuePropName="checked"
          noStyle
        >
          <Checkbox>Remember me</Checkbox>
        </AntdForm.Item>

        <NavLink to="/forgot-password" style={{ float: 'right' }}>
          Forgot password?
        </NavLink>
      </Row>

      <Submit
        validateSubmit={validateSubmit}
        requiredFields={requiredFields}
        itemClassName={clsx(styles.submit, additionalStyles?.submit)}
        loading={loading}
        className={styles.btn}
        size="large"
      >
        Log in
      </Submit>
    </AntdForm>
  );
}

export default Form;
